var auth = (function (globalObj, $) {

	var tool = globalObj.tool = globalObj.tool || {};

  tool.loginGoogle = () =>  {
    var provider = new firebase.auth.GoogleAuthProvider();
    var user = {};
    provider.addScope('profile');
    provider.addScope('email');
    provider.setCustomParameters({
      'hd': 'therooftop.io'
    });
    const promise = firebase.auth().signInWithPopup(provider);

    promise
      .then(res => {
        user['token'] = res.credential.accessToken;
        user['info']  = res.user;
        console.log(res)
      })
      .catch(e => console.log(e.message));
    return user;
  };

  tool.checkUserAuthStatus = () => {
    const user = firebase.auth().currentUser;
    let loggedIn = false;
    if (user) {
      loggedIn = true;
    } else {
      loggedIn = false;
    }
    return loggedIn;
  };

  tool.logout = () => {
		return firebase.auth().signOut();
  };

  return globalObj;
}(auth || {}, jQuery));